import { deAT } from "../../../../date-fns/locale/de-AT.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    deAT
  }
};